import { render } from "./WangEditor.vue?vue&type=template&id=5f30bf68&ts=true"
import script from "./WangEditor.vue?vue&type=script&lang=ts"
export * from "./WangEditor.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__